import React            from 'react';
import TimelineActivity from '~/components/drawers/timeline/activity';

const TimelineActivityCandidateAdded = ({
  icon = 'briefcase',
  prefix = 'far',
  color = 'text-grey-dark',
  title = (obj) => {
    const { activity } = obj.props;
    const {
      job_title, location, added_by, name = 'Candidate',
    } = activity.parameters || {};

    return (
      `${name} was added${added_by ? ` by ${added_by}` : ''} to ${job_title} Job${location ? ` in ${location}` : ''}`
    );
  },
  ...props
}) => <TimelineActivity {...props} icon={icon} prefix={prefix} color={color} title={title} />;

export default TimelineActivityCandidateAdded;
